module.exports = {"defaultFileName":"List","errorOccurred":"An error occurred."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/excel.json
// module id = pRop
// module chunks = 2